import { Button, PlusIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAddFontCollection } from "../../../hooks/libraries/fontCollections/useAddFontCollection";

export const AddFontCollectionButton: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [addFontCollection, isLoading] = useAddFontCollection();

  return (
    <Button
      key="font-collection-add"
      type="primary"
      icon={<PlusIcon />}
      onClick={async () => {
        const fontCollection = await addFontCollection();

        if (fontCollection) {
          navigate(
            `/libraries/font-collections/embroidery/${fontCollection.id!}`
          );
        }
      }}
      loading={isLoading}
    >
      {t("font_collections.actions.add.button")}
    </Button>
  );
};
